import { Injectable } from '@angular/core';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  constructor(private loadingController: LoadingController,
              private toastCtrl: ToastController,
              private alertController: AlertController) { }

  async presentLoading(loadingId: string, loadingMessage: string) {
    const loading = await this.loadingController.create({
      id: loadingId,
      message: loadingMessage
    });
    await loading.present();
    return loading;
  }

  async dismiss(loadingId: string) {
    return this.loadingController.dismiss(null, null, loadingId);   
  }
  
  async presentToast(text, duration=3000, color="dark") {
    const toast = await this.toastCtrl.create({
        message: text,
        position: 'bottom',
        color: color,
        duration: duration
    });
    toast.present();
    return toast;
  }

  async presentAlertConfirm(header, message, callback) {    
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: header,
      message: message,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {            
            this.alertController.dismiss();
          }
        }, {
          text: 'Yes',
          handler: () => {            
            callback();                         
          }
        }
      ]
    });

    await alert.present();
  }
}